import {
  DTODobBinLookup,
  DTOResponseDobBinLookup,
} from "./Lookup/DobBin/DobBin.interface";
import axiosBase from "./axiosBase";

export const callDobBinLookup = async (address: DTODobBinLookup) => {
  const response = await axiosBase.post<DTOResponseDobBinLookup>(
    "/lookup/dob-bin",
    address,
  );
  return response.data;
};
